import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=513047d3&scoped=true"
import script from "./Speech.vue?vue&type=script&lang=js"
export * from "./Speech.vue?vue&type=script&lang=js"
import style0 from "./Speech.vue?vue&type=style&index=0&id=513047d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513047d3",
  null
  
)

export default component.exports